import { render, staticRenderFns } from "./OccupancyListView.vue?vue&type=template&id=b051eca8&scoped=true"
import script from "./OccupancyListView.vue?vue&type=script&lang=js"
export * from "./OccupancyListView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/college/PlaceListView.css?vue&type=style&index=0&id=b051eca8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b051eca8",
  null
  
)

export default component.exports